import { CabeceraPagina } from '../../components/Armazon';
import { Aviso, Boton, Cargando, PildoraLibre, Tarjeta, Vacio } from '../../components/ui';
import { api } from '../../lib/api';
import { fechaHora } from '../../lib/formato';
import { useAvisos, useDatos } from '../../lib/sesion';

interface Incidencias {
  projections: Array<{
    id: string;
    key: string;
    objectType: string;
    audience: string;
    calendarId: string;
    status: string;
    lastError: string | null;
    lastAttemptAt: string | null;
    attempts: number;
    publicCode: string | null;
  }>;
  mails: Array<{
    id: string;
    recipient: string;
    type: string;
    status: string;
    planVersion: number;
    lastError: string | null;
    attempts: number;
    publicCode: string | null;
  }>;
  failedJobs: number;
  modes: { google: string; mail: string };
}

export function Integraciones() {
  const { avisar } = useAvisos();
  const { datos, cargando, error, recargar } = useDatos(
    (s) => api.get<Incidencias>('/admin/integrations', s),
    [],
  );

  if (cargando) return <Cargando />;
  if (error) return <Aviso tono="error">{error}</Aviso>;
  if (!datos) return null;

  const limpio = datos.projections.length === 0 && datos.mails.length === 0 && datos.failedJobs === 0;

  return (
    <>
      <CabeceraPagina
        titulo="Incidencias"
        acciones={
          <Boton variante="secundario" onClick={recargar}>
            Actualizar
          </Boton>
        }
      />

      <div className="pila">
        <Aviso tono={limpio ? 'hecho' : 'aviso'}>
          {limpio
            ? 'Todo sincronizado. No hay envíos ni sincronizaciones pendientes.'
            : `${datos.projections.length} sincronización(es) y ${datos.mails.length} correo(s) pendientes · ${datos.failedJobs} tarea(s) fallidas.`}
        </Aviso>

        <Tarjeta titulo="Calendario" sinRelleno>
          {datos.projections.length === 0 ? (
            <Vacio titulo="Sin incidencias de calendario" />
          ) : (
            <table className="tabla">
              <thead>
                <tr>
                  <th>Solicitud</th>
                  <th>Calendario</th>
                  <th>Destinatario</th>
                  <th>Intentos</th>
                  <th>Error</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {datos.projections.map((p) => (
                  <tr key={p.id}>
                    <td className="codigo">{p.publicCode ?? '—'}</td>
                    <td className="sutil">{p.calendarId}</td>
                    <td>
                      <PildoraLibre
                        texto={p.audience === 'BLOCKED' ? 'Copia anónima' : p.audience === 'MASTER' ? 'Maestro' : 'Comercial'}
                        tono="neutro"
                      />
                    </td>
                    <td className="dato">{p.attempts}</td>
                    <td className="sutil" style={{ maxWidth: 280 }}>
                      {p.lastError ?? '—'}
                      {p.lastAttemptAt && <div>{fechaHora(p.lastAttemptAt)}</div>}
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      <Boton
                        variante="plano"
                        tam="s"
                        onClick={async () => {
                          await api.post(`/admin/integrations/projections/${p.id}/retry`);
                          avisar('Sincronización reencolada.', 'hecho');
                          recargar();
                        }}
                      >
                        Reintentar
                      </Boton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Tarjeta>

        <Tarjeta titulo="Correos" sinRelleno>
          {datos.mails.length === 0 ? (
            <Vacio titulo="Sin correos pendientes" />
          ) : (
            <table className="tabla">
              <thead>
                <tr>
                  <th>Solicitud</th>
                  <th>Destinatario</th>
                  <th>Intentos</th>
                  <th>Error</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {datos.mails.map((m) => (
                  <tr key={m.id}>
                    <td className="codigo">{m.publicCode ?? '—'}</td>
                    <td>{m.recipient}</td>
                    <td className="dato">{m.attempts}</td>
                    <td className="sutil" style={{ maxWidth: 280 }}>
                      {m.lastError ?? '—'}
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      <Boton
                        variante="plano"
                        tam="s"
                        onClick={async () => {
                          await api.post(`/admin/integrations/mails/${m.id}/retry`);
                          avisar('Correo reencolado.', 'hecho');
                          recargar();
                        }}
                      >
                        Reintentar
                      </Boton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Tarjeta>
      </div>
    </>
  );
}
